import { MarketplaceProject } from '@codes/marketplace/marketplace';

import { EmptyMarketplace } from './EmptyMarketplace';
import { ProjectCard } from './ProjectCard';
import { ProjectCardSkeleton } from './ProjectCardSkeleton';

interface MarketplaceGridProps {
    projects: MarketplaceProject[];
    isLoading: boolean;
    onViewDetails: (projectId: string) => void;
    hasFilters?: boolean;
    onClearFilters?: () => void;
}

export const MarketplaceGrid = ({
    projects,
    isLoading,
    onViewDetails,
    hasFilters,
    onClearFilters,
}: MarketplaceGridProps) => {
    if (isLoading) {
        return (
            <div className="grid grid-cols-[repeat(auto-fill,minmax(350px,1fr))] max-xs:grid-cols-1 gap-6">
                {Array.from({ length: 6 }).map((_, index) => (
                    <ProjectCardSkeleton key={index} />
                ))}
            </div>
        );
    }

    if (projects.length === 0) {
        return <EmptyMarketplace hasFilters={hasFilters} onClearFilters={onClearFilters} />;
    }

    return (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(350px,1fr))] max-xs:grid-cols-1 gap-6" role="list">
            {projects.map(project => (
                <div key={project.id} role="listitem">
                    <ProjectCard project={project} onViewDetails={onViewDetails} />
                </div>
            ))}
        </div>
    );
};
